const getDataModels = config => () => {
  return config.resources;
};

export default getDataModels;
